import React, { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import * as sdk from "boa-sdk-ts";
import TransactionOverview from "./sendBoaOverview";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../../actions/addresses";
import SecretSeedModal from "../sharedComponent/secretSeedModal";
import BalanceSummary from "../sharedComponent/balanceSummary";
import FeeOption from "../sharedComponent/feeOption";
import BoaAddSenderModal from "../sharedComponent/BoaAddSenderModal";
import { usePrevious } from "../../../hooks/usePrevious";
import Receiver from "../sharedComponent/receiver";
import { loadContactList } from "../../../utils/WalletUtils";
import { WalletResultCode } from "boa-sdk-ts";
import { WalletMA } from "boa-sdk-ts";
import { ErrorCheckUtil } from "../../../utils/ErrorCheckUtil";
import SenderDeleteModal from "../sharedComponent/senderDeleteModal";

const SendBoa = (props) => {
  // These are all states use in this component
  const { t } = useTranslation();
  const { selectedAddress } = props;

  // popup visible control
  const [showConfirm, setShowConfirm] = useState(false);
  const [secretKeyModal, setSecretKeyModal] = useState(false);

  // variable
  const [receiverAddress, setReceiverAddress] = useState("");
  const preAddress = usePrevious(receiverAddress);
  const [receiverAddressValidated, setReceiverAddressValidated] =
    useState(false);
  const [contentList, setContentList] = useState([]);

  const [amount, SetAmount] = useState("0");
  const preAmount = usePrevious(amount);
  const [amountWithCommas, SetAmountWithCommas] = useState("");
  const [fee, SetFee] = useState("");
  const [senderBtnStatus, setSenderBtnStatus] = useState(true);
  const [deletedAccount, setDeletedAccount] = useState();
  const [feeOption, setFeeOption] = useState("1");
  const preFeeOption = usePrevious(feeOption);
  const [AddressError, SetAddressError] = useState(null);
  const [FeeError, SetFeeError] = useState(null);
  const [amountError, setAmountError] = useState(null);

  const [openConfirmDeletion, setConfirmDeletion] = useState(false);
  const [senderListLoader, setSenderListLoader] = useState(false);
  const [senderList, setSenderList] = useState([]);

  const [readModeList, setReadModeList] = useState([]);
  const [transactionOverviewData, setTransactionOverviewData] = useState();

  const { accounts, builders, client } = WalletMA.instance();

  // Method use to get public addresses from contact list
  useEffect(() => {
    console.log("SEND_BOA_INIT");
    const list = loadContactList();
    if (list) {
      let contactList = list.map((info) => {
        if (
          info &&
          info != "undefined" &&
          info.contactWalletAddress &&
          selectedAddress != info.contactWalletAddress
        ) {
          return {
            publicKey: info.contactWalletAddress,
            contactName: info.contactAddressName,
          };
        }
      });
      setContentList(contactList);
    }
    initBuilder();
    return () => {
      console.log("SEND_BOA_END");
      const builder = getBuilder();
      if (builder) {
        builder.removeEventListener(
          sdk.Event.CHANGE_BALANCE,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_RECEIVER,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_SENDER,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_TX_FEE,
          buildersEventHandler
        );
        builder.removeEventListener(
          sdk.Event.CHANGE_PAYLOAD_FEE,
          buildersEventHandler
        );
        builder.removeEventListener(sdk.Event.ERROR, buildersEventHandler);
        builder.clear();
      }

      builders.delete("SEND_BOA");
    };
  }, []);

  useEffect(() => {
    if (selectedAddress) {
      replaceSender();
    }
    if (showConfirm) {
      setShowConfirm(false);
    }
  }, [selectedAddress]);

  // Change receiver address  Effect
  useEffect(() => {
    if (receiverAddress) {
      validatePublicKey();
    }
  }, [receiverAddress]);

  // Change Amount Effect
  useEffect(() => {
    if (amount) {
      if (amount !== preAmount) replaceReceive();
    } else {
      setSenderBtnStatus(false);
    }
  }, [amount]);

  const initBuilder = async () => {
    const res = await createBuilder();
    setBuilder(res);
  };

  const createBuilder = async () => {
    const builder = new sdk.WalletTxBuilder(client);
    builder.addEventListener(sdk.Event.CHANGE_BALANCE, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_RECEIVER, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_SENDER, buildersEventHandler);
    builder.addEventListener(sdk.Event.CHANGE_TX_FEE, buildersEventHandler);
    builder.addEventListener(
      sdk.Event.CHANGE_PAYLOAD_FEE,
      buildersEventHandler
    );
    builder.addEventListener(sdk.Event.ERROR, buildersEventHandler);
    if (accounts.selected_account) {
      await builder.addSender(
        accounts.selected_account,
        accounts.selected_account.balance.spendable
      );
    }
    return builder;
  };

  const buildersEventHandler = (e, data) => {
    console.log("Event > SendBOA > Builder:" + e + " => " + data);
    switch (e) {
      case sdk.Event.CHANGE_BALANCE:
        break;
      case sdk.Event.CHANGE_RECEIVER:
        break;
      case sdk.Event.CHANGE_SENDER:
        const b = getBuilder();
        if (b) {
          setSenderList([...getBuilder().senders.items]);
        }
        break;
      case sdk.Event.CHANGE_TX_FEE:
        SetFee(data);
        break;
      case sdk.Event.CHANGE_PAYLOAD_FEE:
        break;
      case sdk.Event.ERROR:
        break;
      default:
        break;
    }
  };

  const validatePublicKey = async () => {
    const res = await sdk.WalletValidator.isValidPublicKey(receiverAddress);
    if (res.code === WalletResultCode.Success) {
      setReceiverAddressValidated(true);
      if (selectedAddress === receiverAddress) {
        SetAddressError(t("Create_Send_Transaction"));
      } else {
        SetAddressError("");
      }
      if (receiverAddress === !preAddress) {
        await getBuilder().clearReceiver(false);
      }
      let r = await createReceiver(receiverAddress, amount);
      if (r) {
        await getBuilder().addReceiver(r);
      }
    } else {
      SetAddressError(res.message);
      setReceiverAddressValidated(false);
    }
  };
  // Method to call on focus out of amount field
  const amountFocusout = (status) => {
    const account = accounts.selected_account;
    if (account) {
      SetAmount(amount);
    }
    return;
  };
  const createReceiver = async (publicKey, sendAmount) => {
    let realAmount = await sdk.AmountConverter.fromString(sendAmount);
    if (realAmount.code === WalletResultCode.Success) {
      return {
        address: new sdk.PublicKey(publicKey),
        amount: realAmount.data,
      };
    } else {
      return null;
    }
  };

  const replaceReceive = async () => {
    if (getBuilder() && receiverAddressValidated) {
      let r = await createReceiver(receiverAddress, amount);
      await getBuilder().addReceiver(r);
    }
  };

  const replaceSender = async () => {
    const b = getBuilder();
    if (b) {
      await b.clearSender(false);
      await b.addSender(
        accounts.selected_account,
        accounts.selected_account.balance.spendable
      );
    }
  };
  // Change Fee Option Effect
  useEffect(() => {
    if (getBuilder()) {
      getBuilder().setFeeOption(parseFloat(feeOption));
    }
  }, [feeOption]);

  // FeeOptionChangeEvent
  const feeOptionChangeHandler = async (e) => {
    setFeeOption(e.target.value);
  };

  const getBuilder = () => {
    return builders.get("SEND_BOA");
  };
  const setBuilder = (builder) => {
    builders.set("SEND_BOA", builder);
  };

  // Method to set amount
  const onChangeAmount = (evt) => {
    // New sender should remove custom fee effect
    // setCustomFeeStatus(false);
    if (!evt.target.value) return;
    let isDecimal = /^[-+]?[0-9]+\.[0-9]+$/.test(evt.target.value);
    if (receiverAddressValidated) {
      if (isDecimal) {
        let noDigitAfterDecimal = countDecimals(evt.target.value);
        if (noDigitAfterDecimal > 7) {
          evt.preventDefault();
        } else {
          if (evt.keyCode === 8) {
            SetAmount(evt.target.value.replace(/,/g, ""));
            SetAmountWithCommas(evt.target.value);
          } else {
            SetAmount(evt.target.value.replace(/,/g, ""));
            SetAmountWithCommas(evt.target.value);
          }
        }
      } else {
        if (evt.keyCode === 8) {
          SetAmount(evt.target.value.replace(/,/g, ""));
          SetAmountWithCommas(evt.target.value);
        } else {
          SetAmount(evt.target.value.replace(/,/g, ""));
          SetAmountWithCommas(evt.target.value);
        }
      }
    } else {
      if (isDecimal) {
        let noDigitAfterDecimal = countDecimals(evt.target.value);
        if (noDigitAfterDecimal > 7) {
          evt.preventDefault();
        } else {
          if (evt.keyCode === 8) {
            SetAmount(evt.target.value.replace(/,/g, ""));
            SetAmountWithCommas(evt.target.value);
          } else {
            SetAmount(evt.target.value.replace(/,/g, ""));
            SetAmountWithCommas(evt.target.value);
          }
        }
      } else {
        if (evt.keyCode === 8) {
          SetAmount(evt.target.value.replace(/,/g, ""));
          SetAmountWithCommas(evt.target.value);
        } else {
          SetAmount(evt.target.value.replace(/,/g, ""));
          SetAmountWithCommas(evt.target.value);
        }
      }
      SetAddressError(t("Enter_valid_receiver_address_first"));
    }
  };

  // User custom Fee Change
  const onChangeFee = (evt) => {
    //TODO: Change custom Fee
  };

  // Delete Sender transaction from list
  const deleteSender = (deletedRecord) => {
    setConfirmDeletion(true);
    setDeletedAccount(deletedRecord.account);
  };

  const deleteSenderConfirm = (value) => {
    if (value) {
      const builder = getBuilder();
      builder.removeSender(deletedAccount);
    }
    setDeletedAccount(null);
    setConfirmDeletion(false);
  };

  var countDecimals = function (value) {
    let text = value.toString();
    // verify if number 0.000005 is represented as "5e-6"
    if (text.indexOf("e-") > -1) {
      let [base, trail] = text.split("e-");
      let deg = parseInt(trail, 10);
      return deg;
    }
    // count decimals for number in representation like "0.123456"
    if (Math.floor(value) !== value) {
      return value.toString().split(".")[1].length || 0;
    }
    return 0;
  };

  // Method to handletranscation
  const nextTransactionOverview = async (e) => {
    let readModeList = getBuilder().getReadOnlyAccount();
    if (readModeList.length > 0) {
      setReadModeList(readModeList);
      setSecretKeyModal(true);
    } else {
      getTransactionOverview();
    }
  };

  const secretSeedModalCloseHandler = () => {
    setSecretKeyModal(false);
    if (getBuilder().getReadOnlyAccount().length === 0) {
      getTransactionOverview();
    }
  };

  const getTransactionOverview = async () => {
    const builder = builders.get("SEND_BOA");
    const res = await builder.getTransactionOverview();
    if (ErrorCheckUtil.resCodeCheck(res) && res.data) {
      setTransactionOverviewData(res.data);
      setShowConfirm(true);
    }
  };

  // Methon to send Agora Transaction
  const sendToAgoraTransaction = async () => {
    const builder = builders.get("SEND_BOA");
    const tx_res = builder.buildTransaction();

    if (ErrorCheckUtil.resCodeCheck(tx_res)) {
      const tx = tx_res.data;
      const res = await client.sendTransaction(tx);
      if (ErrorCheckUtil.resCodeCheck(res)) {
        props.history.push("/success");
      }
    }
  };

  // Method to hide confirm div
  const hideConfirmDiv = () => {
    setShowConfirm(false);
  };
  const addSenderHandler = (account) => {
    if (account) {
      const builder = getBuilder();
      builder.addSender(account, account.balance.spendable);
    }
  };

  return (
    <>
      {showConfirm ? (
        <TransactionOverview
          hideConfirmDiv={hideConfirmDiv}
          sendToAgoraTransaction={sendToAgoraTransaction}
          transactionOverviewData={transactionOverviewData}
        />
      ) : (
        <div className="Content">
          <Receiver
            ReceiverAddress={receiverAddress}
            contentList={contentList}
            AddressError={AddressError}
            onChangeAmount={onChangeAmount}
            amountError={amountError}
            amountFocusout={amountFocusout}
            amountWithCommas={amountWithCommas}
            setReceiverAddress={setReceiverAddress}
          />
          {/* Select Fee Option Component */}
          <FeeOption
            fee={fee}
            feeOption={feeOption}
            error={FeeError}
            feeOptionChangeHandler={feeOptionChangeHandler}
          />
          <div className="TableBg cardBg mt-30">
            {/* BOA Add Sender Modal Component */}
            <BoaAddSenderModal
              senderList={senderList}
              senderBtnStatus={
                !(
                  getBuilder() &&
                  getBuilder().remaining &&
                  parseFloat(getBuilder().remaining.toString()) > 0
                )
              }
              remaining={getBuilder() && getBuilder().remaining}
              addSenderHandler={addSenderHandler}
            />
            {/* Sender List Balance Summary Component  */}
            <BalanceSummary
              props={props}
              senderList={senderList}
              deleteSender={deleteSender}
              senderListLoader={senderListLoader}
            />
            <div className="TransactionFee">
              {/* Button to redirect Send BOA transaction screen */}
              <div />
              <button
                className="btn btn-default senderBtn"
                disabled={
                  !(
                    getBuilder() &&
                    receiverAddressValidated &&
                    getBuilder().validate().code === WalletResultCode.Success
                  )
                }
                color="primary"
                onClick={(e) => nextTransactionOverview(e)}
              >
                {t("NEXT")}
              </button>
            </div>
          </div>
        </div>
      )}
      <SecretSeedModal
        readModeList={readModeList}
        secretKeyModal={secretKeyModal}
        secretSeedModalCloseHandler={secretSeedModalCloseHandler}
      />
      {/* Delete Sender Confirmation Modal  */}
      <SenderDeleteModal
        deleteSenderConfirm={deleteSenderConfirm}
        openConfirmDeletion={openConfirmDeletion}
      />
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SendBoa))
);
